import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "output", "user"]

  changedItem(event) {
    var typeOText = event.target.value;
    var wordsOfType = this.inputTarget.getElementsByClassName(typeOText);
    var startWord = wordsOfType[0].firstElementChild;
    if (startWord.hasAttribute('id') == false) {
      startWord = startWord.firstElementChild;
    }
    var endWord = wordsOfType[wordsOfType.length - 1].lastElementChild;
    if (endWord.hasAttribute('id') == false) {
      endWord = endWord.lastElementChild;
    }

    this.outputTarget.querySelector('.text_interpretations_start_word_id').querySelector('input').setAttribute('value', startWord.id);
    this.outputTarget.querySelector('.text_interpretations_end_word_id').querySelector('input').setAttribute('value', endWord.id);
    this.outputTarget.querySelector('.text_interpretations_user_id').querySelector('input').setAttribute('value', this.userTarget.value);

  }
}
